module.exports = __webpack_public_path__ + "fonts/OpenSans-ExtraBold.ce615223.ttf";